import {
  Drawer,
  Grid,
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  Typography,
  TextField,
  FormControlLabel,
  Card,
  Button,
  Tabs,
  Tab,
  IconButton,
  CardContent,
  Chip,
  MenuItem,
  Alert,
  styled,
  TableContainer,
  Paper,
  Stack,
  alpha,
} from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { TabProps } from '../../utils/tabProps';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { api_file_url_cmd_fb } from '../../config/Params.constant';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateCmdFournisseur,
  uploadPhotoCmdFournisseur,
  viewCmdFournisseur,
} from '../../redux/slices/commande-fournisseur.slice';
import { metaux } from '../../utils/metaux.enum';
import { getPublicListFournisseur } from '../../redux/slices/fournisseur.slice';
import { api_file_url_catalogue } from '../../config/Params.constant';
import DefaultImg from '../../assets/images/backgrounds/img-default.png';
import ImageZoomer from '../../components/image/ImageZoomer';
import QRCode from 'react-qr-code';
import { useReactToPrint } from 'react-to-print';
import { formatFrenchDate } from '../../utils/helper';
import { CmdFournisseurStatus } from '../../utils/commande.enums';
import { Section, SectionHeader } from '../../views/comm/SectionHeader';
import { MiniChip, StatBox } from '../../views/comm/MiniChip';
import FileUploadModal from '../../components/modal/FileUploadModal';
import {
  Close,
  Edit,
  CheckCircle,
  WarningAmber,
  Whatshot,
  LocalShipping,
  Person,
  Store,
  Print,
  UploadFile,
  Delete,
  Build,
  NoteAdd,
  History,
  FactCheck,
  InfoOutlined,
  Diamond,
  Schedule,
  Euro,
  PhotoCamera,
  Article,
  Inventory,
  Receipt,
  Add,
  ContentCopy,
  OpenInNew,
  DescriptionOutlined,
  LocalOfferOutlined,
  LocalShippingOutlined,
} from '@mui/icons-material';

const CmdFbDetailsWidget = ({ show, onClose, idCmdFournisseur }) => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state?.cmd_achat_store);
  const [sel_tab, set_sel_tab] = useState(0);
  const [cmd, set_cmd] = useState(null);
  const [lst_fournisseur, set_lst_fournisseur] = useState([]);

  const handleChange = (event, newValue) => {
    set_sel_tab(newValue);
  };

  const load_data = () => {
    if (idCmdFournisseur)
      dispatch(viewCmdFournisseur(idCmdFournisseur))
        .unwrap()
        .then((res) => {
          set_cmd(res);
        })
        .catch((err) => console.log(err));
  };
  const load_fb = () => {
    dispatch(getPublicListFournisseur())
      .unwrap()
      .then((res) => {
        set_cmd(res);
      })
      .catch((err) => console.log(err));
  };

  const onUpdateCmd = (data) => {
    if (data)
      dispatch(updateCmdFournisseur(data))
        .unwrap()
        .then((res) => {
          load_data();
        })
        .catch((err) => console.log(err));
  };

  const onUploadPhotoJoint = (file, field) => {
    const formData = new FormData();
    formData.append('file', file);
    if (cmd && file && field) {
      dispatch(uploadPhotoCmdFournisseur(formData))
        .unwrap()
        .then((res) => {
          const path = res?.path;
          if (path) {
            onUpdateCmd({
              idCmdFournisseur: cmd?.idCmdFournisseur,
              [field]: path,
            });
          }
        })
        .catch((err) => console.error(err));
    }
  };

  useEffect(() => {
    load_data();
  }, [idCmdFournisseur]);

  useEffect(() => {
    load_fb();
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case 'nouvel':
        return '#2196F3';
      case 'en-attente':
        return '#e08e2b';
      case 'en-cours':
        return '#9761cd';
      case 'envoye-fabricant':
        return '#00a86b';
      case 'a-saisir':
        return '#e08e2b';
      case 'en-etiquetage':
        return '#c9a92c';
      case 'failed-cq':
        return '#e2445c';
      case 'envoye-mg':
        return '#0484c2';
      case 'prete':
      case 'a-expedier':
      case 'livre':
        return '#159073';
      default:
        return '#546e7a';
    }
  };

  const statusColor = getStatusColor(cmd?.status);

  return (
    <Drawer
      anchor={'right'}
      open={show}
      onClose={onClose}
      PaperProps={{
        sx: { width: { xs: '100%', lg: '75%' } },
      }}
    >
      <Box sx={{ minHeight: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* Hero Top Bar Header */}
        <Paper
          square
          elevation={0}
          sx={{
            p: 2.5,
            bgcolor: 'background.paper',
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: 2,
                  bgcolor: alpha(statusColor, 0.14),
                  color: statusColor,
                  display: 'grid',
                  placeItems: 'center',
                }}
              >
                <Article fontSize="medium" />
              </Box>
              <Box>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Typography variant="h5" fontWeight={700}>
                    Commande #{cmd?.ref || '--'}
                  </Typography>
                  {cmd?.is_urgent && (
                    <Chip
                      size="small"
                      color="error"
                      icon={<Whatshot fontSize="small" />}
                      label="URGENT"
                      sx={{ fontWeight: 700, borderRadius: 1 }}
                    />
                  )}
                </Stack>
                {cmd?.ref_monday && (
                  <Typography variant="caption" color="text.secondary">
                    Réf. Monday: <strong style={{marginRight : 20}}>{cmd.ref_monday}</strong>
                  </Typography>
                )}
                <MiniChip color={cmd?.magasin?.bg_color || '#a09fb7'} label={cmd?.magasin?.code} icon={<StorefrontIcon/>} />
              </Box>
            </Stack>

            <IconButton onClick={onClose} size="small" sx={{ bgcolor: alpha('#000', 0.04) }}>
              <Close fontSize="small" />
            </IconButton>
          </Stack>

          {/* Quick Resumé KPI Strip */}
          <Grid container spacing={1.5}>
            <Grid item xs={6} sm={2.4}>
              <StatBox
                label="Statut"
                value={cmd?.status || 'N/A'}
                color={statusColor}
                // subvalue={cmd?.type_commande}
              />
            </Grid>
            <Grid item xs={6} sm={2.4}>
              <StatBox
                label="Fournisseur"
                value={cmd?.fournisseur?.nomSociete || 'Central'}
                color="#0484c2"
              />
            </Grid>
            <Grid item xs={6} sm={2.4}>
              <StatBox
                label="Client"
                value={
                  cmd?.client ? `${cmd.client.nom} ${cmd.client.prenom || ''}` : 'Stock central'
                }
                color="#159073"
                // subvalue={cmd?.magasin?.code ? `Magasin: ${cmd.magasin.code}` : null}
              />
            </Grid>
            <Grid item xs={6} sm={2.4}>
              <StatBox
                label="Date Livraison Prévue"
                value={
                  cmd?.date_livraison_prevu
                    ? formatFrenchDate(String(cmd.date_livraison_prevu).slice(0, 10))
                    : '--'
                }
                color="#e08e2b"
                subvalue={
                  cmd?.date_urgent
                    ? `Urgent: ${formatFrenchDate(String(cmd.date_urgent).slice(0, 10))}`
                    : null
                }
              />
            </Grid>
            <Grid item xs={6} sm={2.4}>
              <StatBox
                label="Prix Vente TTC"
                value={
                  cmd?.catalogue?.is_sur_mesure || cmd?.catalogue?.is_hc
                    ? `${cmd?.prix_sur_mesure_ttc || 0} €`
                    : `${cmd?.catalogue?.prix_vente_ttc || 0} €`
                }
                color="#8a55c4"
                // subvalue={
                //   cmd?.num_dhl
                //     ? `DHL: ${cmd.num_dhl}`
                //     : cmd?.taille
                //       ? `Taille: ${cmd.taille}`
                //       : null
                // }
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Navigation Tabs */}
        <Box
          sx={{
            bgcolor: 'background.paper',
            borderBottom: '1px solid',
            borderColor: 'divider',
            px: 2,
          }}
        >
          <Tabs
            value={sel_tab}
            onChange={(e, val) => set_sel_tab(val)}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab
              icon={<InfoOutlined fontSize="small" />}
              iconPosition="start"
              label="Informations"
            />
            <Tab
              icon={<WarningAmber fontSize="small" />}
              iconPosition="start"
              label={
                <Stack direction="row" alignItems="center" spacing={0.75}>
                  <span>Blocages</span>
                  {Boolean(cmd?.bloquages?.length) && (
                    <Chip
                      size="small"
                      color="error"
                      label={cmd.bloquages.length}
                      sx={{ height: 18, fontSize: '0.68rem' }}
                    />
                  )}
                </Stack>
              }
            />
            <Tab
              icon={<NoteAdd fontSize="small" />}
              iconPosition="start"
              label={
                <Stack direction="row" alignItems="center" spacing={0.75}>
                  <span>Notes</span>
                  {Boolean(cmd?.notes?.length) && (
                    <Chip
                      size="small"
                      color="secondary"
                      label={cmd.notes.length}
                      sx={{ height: 18, fontSize: '0.68rem' }}
                    />
                  )}
                </Stack>
              }
            />
            <Tab
              icon={<FactCheck fontSize="small" />}
              iconPosition="start"
              label="Contrôle Qualité"
            />
            <Tab
              icon={<History fontSize="small" />}
              iconPosition="start"
              label={
                <Stack direction="row" alignItems="center" spacing={0.75}>
                  <span>Historique</span>
                  {Boolean(cmd?.historiques?.length) && (
                    <Chip
                      size="small"
                      variant="outlined"
                      label={cmd.historiques.length}
                      sx={{ height: 18, fontSize: '0.68rem' }}
                    />
                  )}
                </Stack>
              }
            />
          </Tabs>
        </Box>

        {/* Main Content Area */}
        <Box
          sx={{
            p: 2.5,
            flexGrow: 1,
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: `${alpha('#67c1d3', 0.4)} transparent`,
            '&::-webkit-scrollbar': { width: 6 },
            '&::-webkit-scrollbar-thumb': { backgroundColor: alpha('#67c1d3', 0.4), borderRadius: 3 },
          }}
        >
          {sel_tab === 0 && (
            <CmdInfoSection
              cmd={cmd}
              onUpdateValues={onUpdateCmd}
              lst_fournisseur={lst_fournisseur}
              onUploadPhotoJoint={onUploadPhotoJoint}
              loading={loading}
              load_data={load_data}
            />
          )}
          {sel_tab === 1 && <CmdBlocageSection cmd={cmd} onUpdateValues={onUpdateCmd} />}
          {sel_tab === 2 && <CmdNoteSection cmd={cmd} onUpdateValues={onUpdateCmd} />}
          {sel_tab === 3 && <ControleQualiteSection cmd={cmd} />}
          {sel_tab === 4 && <CmdHistoriqueSection cmd={cmd} />}
        </Box>
      </Box>
    </Drawer>
  );
};

const CmdInfoSection = ({ cmd, onUpdateValues, lst_fournisseur, onUploadPhotoJoint, loading }) => {
  const default_form_urg_values = { date_urgent: null };
  const default_form_liv_values = { date_livraison: null };
  const [show_urg_form, set_show_urg_form] = useState(false);
  const [show_liv_form, set_show_liv_form] = useState(false);
  const [show_fb_form, set_show_fb_form] = useState(false);
  const [form_urg_values, set_form_urg_values] = useState(default_form_urg_values);
  const [form_liv_values, set_form_liv_values] = useState(default_form_liv_values);
  const [form_fb_values, set_form_fb_values] = useState(null);
  const [show_taille_grav_form, set_show_taille_grav_form] = useState(false);
  const [form_taille_grav_values, set_form_taille_grav_values] = useState(null);
  const [show_monday_form, set_show_monday_form] = useState(false);
  const [form_monday_value, set_form_monday_value] = useState(cmd?.ref_monday ?? '');
  const [show_dhl_modal, set_show_dhl_modal] = useState(false);
  const [sel_num_dhl, set_sel_num_dhl] = useState('');

  const [sel_upload_photo, set_sel_upload_photo] = useState(null);
  const [show_file_modal, set_show_file_modal] = useState(false);

  const renderStatus = (status) => {
    switch (status) {
      case 'nouvel':
        return (
          <Chip
            sx={{
              backgroundColor: '#2196F3',
              color: '#fff',
              borderRadius: '3px',
              px: '3px',
            }}
            size="small"
            label={status}
          />
        );

      case 'en-attente':
        return (
          <Chip
            sx={{
              backgroundColor: '#f3ae53',
              color: '#fff',
              borderRadius: '3px',
              px: '3px',
            }}
            size="small"
            label={status}
          />
        );

      case 'en-cours':
        return (
          <Chip
            sx={{
              backgroundColor: '#9761cd',
              color: '#fff',
              borderRadius: '3px',
              px: '3px',
            }}
            size="small"
            label={status}
          />
        );
      case 'envoye-fabricant':
        return (
          <Chip
            sx={{
              backgroundColor: '#00c875',
              color: '#fff',
              borderRadius: '3px',
              px: '3px',
            }}
            size="small"
            label={status}
          />
        );

      default:
        return (
          <Chip
            sx={{
              backgroundColor: '#0484c2',
              color: '#fff',
              borderRadius: '3px',
              px: '3px',
            }}
            size="small"
            label={status}
          />
        );
    }
  };

  const onConfirmPhotoUpload = (file) => {
    if (sel_upload_photo) {
      onUploadPhotoJoint(file, sel_upload_photo);
      set_show_file_modal(false);
    }
  };

  const onOpenPhotoUploadModal = (field) => {
    set_sel_upload_photo(field);
    set_show_file_modal(true);
  };

  const onSetUrgent = () => {
    if (form_urg_values.date_urgent) {
      let tmp = {
        idCmdFournisseur: cmd?.idCmdFournisseur,
        is_urgent: true,
        date_urgent: form_urg_values?.date_urgent,
      };
      onUpdateValues(tmp);
      set_form_urg_values(default_form_urg_values);
      set_show_urg_form(false);
    }
  };

  const onSetFournisseur = () => {
    if (form_fb_values?.idFournisseur) {
      let tmp = {
        idCmdFournisseur: cmd?.idCmdFournisseur,
        fournisseur: { idFournisseur: form_fb_values?.idFournisseur },
      };
      onUpdateValues(tmp);
      set_form_fb_values(null);
      set_show_fb_form(false);
    }
  };

  const onSetNonUrgent = () => {
    let tmp = {
      idCmdFournisseur: cmd?.idCmdFournisseur,
      is_urgent: false,
      date_urgent: null,
    };
    onUpdateValues(tmp);
  };

  const onUpdateDateLivraison = () => {
    if (form_liv_values.date_livraison) {
      let tmp = {
        idCmdFournisseur: cmd?.idCmdFournisseur,
        date_livraison: form_liv_values?.date_livraison,
      };
      onUpdateValues(tmp);
      set_form_liv_values(default_form_liv_values);
      set_show_liv_form(false);
    }
  };

  const onUpdateRefMonday = () => {
    let tmp = {
      idCmdFournisseur: cmd?.idCmdFournisseur,
      ref_monday: form_monday_value ?? '',
    };
    onUpdateValues(tmp);
    set_form_monday_value('');
    set_show_monday_form(false);
  };

  const onUpdateTailleGravure = () => {
    if (form_taille_grav_values.taille) {
      let tmp = {
        idCmdFournisseur: cmd?.idCmdFournisseur,
        taille: form_taille_grav_values?.taille,
        gravure: form_taille_grav_values?.gravure,
        sku_externe: form_taille_grav_values?.sku_externe,
      };
      onUpdateValues(tmp);
      set_show_taille_grav_form(false);
    }
  };

  const findCataloguDelaisLivraison = (catalogue) => {
    if (Array.isArray(catalogue?.sku_fb)) {
      const match = catalogue.sku_fb.find((el) => el?.is_default_fb);
      if (match?.delais_livraison) return Number(match.delais_livraison);
    }
    return Number(catalogue?.delais_livraison || 0);
  };

  const onDeletePhoto = (field) => {
    if (field && cmd?.idCmdFournisseur) {
      onUpdateValues({
        idCmdFournisseur: cmd.idCmdFournisseur,
        [field]: null,
      });
    }
  };

  const onUpdateNumDhl = () => {
    let tmp = {
      idCmdFournisseur: cmd?.idCmdFournisseur,
      num_dhl: sel_num_dhl ?? '',
    };
    onUpdateValues(tmp);
    set_sel_num_dhl('');
    set_show_dhl_modal(false);
  };

  useEffect(() => {
    set_form_taille_grav_values({
      taille: cmd?.taille,
      gravure: cmd?.gravure,
      sku_externe: cmd?.sku_externe,
    });
  }, [cmd]);

  return (
    <Box>
      {/* Action Toolbar Panel */}
      <Section sx={{ mb: 2 }}>
        <SectionHeader
          icon={<Build fontSize="small" />}
          color="#159073"
          title="Barre d'Actions Rapides"
          subtitle="Modifications et impression"
          right={<BonCommandePrintButton commande={cmd} />}
        />
        <Box sx={{ px: 2, pb: 2 }}>
          <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
            {!cmd?.is_urgent ? (
              <Button
                variant="outlined"
                color="error"
                size="small"
                startIcon={<Whatshot fontSize="small" />}
                onClick={() => set_show_urg_form(true)}
              >
                Mettre Urgent
              </Button>
            ) : (
              <Button
                variant="contained"
                color="error"
                size="small"
                startIcon={<Whatshot fontSize="small" />}
                onClick={onSetNonUrgent}
              >
                Mettre Non-Urgent
              </Button>
            )}

            <Button
              variant="outlined"
              color="primary"
              size="small"
              startIcon={<Schedule fontSize="small" />}
              onClick={() => set_show_liv_form(true)}
            >
              Date Livraison
            </Button>

            <Button
              variant="outlined"
              color="success"
              size="small"
              startIcon={<LocalShipping fontSize="small" />}
              onClick={() => set_show_fb_form(true)}
            >
              Changer Fournisseur
            </Button>

            <Button
              variant="outlined"
              color="secondary"
              size="small"
              startIcon={<Edit fontSize="small" />}
              onClick={() => set_show_taille_grav_form(true)}
            >
              Taille & Gravure
            </Button>

            <Button
              variant="outlined"
              color="info"
              size="small"
              onClick={() => set_show_monday_form(true)}
            >
              Réf Monday
            </Button>

            {(cmd?.status === CmdFournisseurStatus.PRETE ||
              cmd?.status === CmdFournisseurStatus.A_EXPEDIE) && (
              <Button
                variant="outlined"
                color="warning"
                size="small"
                startIcon={<LocalShippingOutlined fontSize="small" />}
                onClick={() => set_show_dhl_modal(true)}
              >
                N° DHL
              </Button>
            )}
          </Stack>

          {/* Inline Action Forms */}
          {show_urg_form && (
            <Paper
              variant="outlined"
              sx={{ p: 2, mt: 2, bgcolor: alpha('#e2445c', 0.05), borderColor: '#e2445c' }}
            >
              <Typography variant="subtitle2" fontWeight={700} mb={1}>
                Fixer la Date Urgente
              </Typography>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <TextField
                  type="date"
                  size="small"
                  value={form_urg_values?.date_urgent || ''}
                  onChange={(e) => set_form_urg_values({ date_urgent: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
                <Button variant="contained" color="error" size="small" onClick={onSetUrgent}>
                  Confirmer Urgent
                </Button>
                <Button size="small" onClick={() => set_show_urg_form(false)}>
                  Annuler
                </Button>
              </Stack>
            </Paper>
          )}

          {show_fb_form && (
            <Paper
              variant="outlined"
              sx={{ p: 2, mt: 2, bgcolor: alpha('#0484c2', 0.05), borderColor: '#0484c2' }}
            >
              <Typography variant="subtitle2" fontWeight={700} mb={1}>
                Changer de Fournisseur
              </Typography>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <TextField
                  select
                  size="small"
                  sx={{ minWidth: 240 }}
                  value={form_fb_values?.idFournisseur || ''}
                  onChange={(e) => {
                    const found = lst_fournisseur.find((el) => el.idFournisseur === e.target.value);
                    set_form_fb_values(found);
                  }}
                >
                  {Array.isArray(lst_fournisseur) &&
                    lst_fournisseur.map((el) => (
                      <MenuItem key={el?.idFournisseur} value={el?.idFournisseur}>
                        {el?.nomSociete}
                      </MenuItem>
                    ))}
                </TextField>
                <Button variant="contained" color="success" size="small" onClick={onSetFournisseur}>
                  Enregistrer
                </Button>
                <Button size="small" onClick={() => set_show_fb_form(false)}>
                  Annuler
                </Button>
              </Stack>
            </Paper>
          )}

          {show_liv_form && (
            <Paper
              variant="outlined"
              sx={{ p: 2, mt: 2, bgcolor: alpha('#e08e2b', 0.05), borderColor: '#e08e2b' }}
            >
              <Typography variant="subtitle2" fontWeight={700} mb={1}>
                Modifier la Date de Livraison
              </Typography>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <TextField
                  type="date"
                  size="small"
                  value={form_liv_values?.date_livraison || ''}
                  onChange={(e) => set_form_liv_values({ date_livraison: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
                <Button
                  variant="contained"
                  color="warning"
                  size="small"
                  onClick={onUpdateDateLivraison}
                >
                  Modifier Date
                </Button>
                <Button size="small" onClick={() => set_show_liv_form(false)}>
                  Annuler
                </Button>
              </Stack>
            </Paper>
          )}

          {show_taille_grav_form && (
            <Paper
              variant="outlined"
              sx={{ p: 2, mt: 2, bgcolor: alpha('#9761cd', 0.05), borderColor: '#9761cd' }}
            >
              <Typography variant="subtitle2" fontWeight={700} mb={1.5}>
                Taille, Gravure & SKU Externe
              </Typography>
              <Grid container spacing={1.5}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Taille"
                    type="number"
                    value={form_taille_grav_values?.taille || ''}
                    onChange={(e) =>
                      set_form_taille_grav_values({
                        ...form_taille_grav_values,
                        taille: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Gravure"
                    value={form_taille_grav_values?.gravure || ''}
                    onChange={(e) =>
                      set_form_taille_grav_values({
                        ...form_taille_grav_values,
                        gravure: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="SKU Externe"
                    value={form_taille_grav_values?.sku_externe || ''}
                    onChange={(e) =>
                      set_form_taille_grav_values({
                        ...form_taille_grav_values,
                        sku_externe: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} textAlign="end">
                  <Button
                    size="small"
                    onClick={() => set_show_taille_grav_form(false)}
                    sx={{ mr: 1 }}
                  >
                    Annuler
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={onUpdateTailleGravure}
                  >
                    Valider Modifications
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          )}

          {show_monday_form && (
            <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
              <Typography variant="subtitle2" fontWeight={700} mb={1}>
                Référence Monday
              </Typography>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <TextField
                  size="small"
                  placeholder="ID / Ref Monday"
                  value={form_monday_value}
                  onChange={(e) => set_form_monday_value(e.target.value)}
                />
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={onUpdateRefMonday}
                >
                  Enregistrer
                </Button>
                <Button size="small" onClick={() => set_show_monday_form(false)}>
                  Annuler
                </Button>
              </Stack>
            </Paper>
          )}

          {show_dhl_modal && (
            <Paper
              variant="outlined"
              sx={{ p: 2, mt: 2, bgcolor: alpha('#0484c2', 0.05), borderColor: '#0484c2' }}
            >
              <Typography variant="subtitle2" fontWeight={700} mb={1}>
                Numéro de Suivi DHL
              </Typography>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <TextField
                  size="small"
                  placeholder="N° DHL"
                  value={sel_num_dhl}
                  onChange={(e) => set_sel_num_dhl(e.target.value)}
                />
                <Button variant="contained" color="warning" size="small" onClick={onUpdateNumDhl}>
                  Sauvegarder N° DHL
                </Button>
                <Button size="small" onClick={() => set_show_dhl_modal(false)}>
                  Annuler
                </Button>
              </Stack>
            </Paper>
          )}
        </Box>
      </Section>

      {/* Prominent Descriptions & Tracking Fields Card */}
      <Section sx={{ mb: 2 }}>
        <SectionHeader
          icon={<DescriptionOutlined fontSize="small" />}
          color="#0484c2"
          title="Descriptions & Suivi"
          subtitle="Informations de commande, sur mesure, SKU externe et DHL"
        />
        <Box sx={{ p: 2, pt: 0 }}>
          <Grid container spacing={2}>
            {/* Description générale */}
            <Grid item xs={12} sm={6}>
              <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 1.5, height: '100%' }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  fontWeight={700}
                  display="block"
                  mb={0.5}
                >
                  DESCRIPTION COMMANDE
                </Typography>
                <Typography variant="body2" color="text.primary" sx={{ whiteSpace: 'pre-line' }}>
                  {cmd?.description || 'Aucune description spécifiée.'}
                </Typography>
              </Paper>
            </Grid>

            {/* Description sur mesure (if sur mesure or hc or available) */}
            <Grid item xs={12} sm={6}>
              <Paper
                variant="outlined"
                sx={{
                  p: 1.5,
                  borderRadius: 1.5,
                  height: '100%',
                  bgcolor:
                    cmd?.catalogue?.is_sur_mesure || cmd?.catalogue?.is_hc
                      ? alpha('#8a55c4', 0.04)
                      : 'transparent',
                  borderColor:
                    cmd?.catalogue?.is_sur_mesure || cmd?.catalogue?.is_hc ? '#8a55c4' : 'divider',
                }}
              >
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0.5}>
                  <Typography variant="caption" color="text.secondary" fontWeight={700}>
                    DESCRIPTION SUR MESURE / HC
                  </Typography>
                  {(cmd?.catalogue?.is_sur_mesure || cmd?.catalogue?.is_hc) && (
                    <Chip
                      size="small"
                      color="secondary"
                      label="Sur Mesure"
                      sx={{ height: 18, fontSize: '0.65rem' }}
                    />
                  )}
                </Stack>
                <Typography variant="body2" color="text.primary" sx={{ whiteSpace: 'pre-line' }}>
                  {cmd?.description_sur_mesure || '---'}
                </Typography>
              </Paper>
            </Grid>

            {/* SKU Externe & Num DHL */}
            <Grid item xs={12} sm={6}>
              <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 1.5 }}>
                <Stack direction="row" alignItems="center" spacing={1} mb={0.5}>
                  <LocalOfferOutlined fontSize="small" color="secondary" />
                  <Typography variant="caption" color="text.secondary" fontWeight={700}>
                    SKU EXTERNE
                  </Typography>
                </Stack>
                <Typography variant="subtitle1" fontWeight={700} color="secondary.main">
                  {cmd?.sku_externe || '--'}
                </Typography>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Paper
                variant="outlined"
                sx={{
                  p: 1.5,
                  borderRadius: 1.5,
                  bgcolor: cmd?.num_dhl ? alpha('#0484c2', 0.05) : 'transparent',
                }}
              >
                <Stack direction="row" alignItems="center" spacing={1} mb={0.5}>
                  <LocalShippingOutlined fontSize="small" color="info" />
                  <Typography variant="caption" color="text.secondary" fontWeight={700}>
                    NUMÉRO DHL / SUIVI
                  </Typography>
                </Stack>
                <Typography variant="subtitle1" fontWeight={700} color="info.main">
                  {cmd?.num_dhl || 'Non renseigné'}
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Section>

      {/* Article Specification Card */}
      <Section sx={{ mb: 2 }}>
        <SectionHeader
          icon={<Diamond fontSize="small" />}
          color="#00a86b"
          title="Détails de l'Article"
          subtitle={cmd?.catalogue?.sku ? `SKU: ${cmd.catalogue.sku}` : ''}
          right={
            cmd?.catalogue?.sku && (
              <Chip
                size="small"
                color="success"
                label={cmd.catalogue.sku}
                sx={{ fontWeight: 700, borderRadius: 1 }}
              />
            )
          }
        />
        <Box sx={{ p: 2, pt: 0 }}>
          <Grid container spacing={2}>
            {/* Image Thumbnail with Zoom */}
            <Grid item xs={12} sm={3} textAlign="center">
              <Box
                sx={{
                  p: 1,
                  borderRadius: 2,
                  bgcolor: (t) => alpha(t.palette.text.primary, 0.04),
                  border: '1px solid',
                  borderColor: 'divider',
                  display: 'inline-block',
                }}
              >
                <ImageZoomer
                  imageUrl={
                    cmd?.catalogue?.img
                      ? `${api_file_url_catalogue}${cmd.catalogue.img}`
                      : DefaultImg
                  }
                  style={{ height: 110, width: 110, objectFit: 'contain' }}
                />
              </Box>
            </Grid>

            {/* Article Attributes Grid */}
            <Grid item xs={12} sm={9}>
              <Typography variant="h6" fontWeight={700} color="success.main" mb={0.5}>
                {cmd?.catalogue?.nom || '--'}
                {cmd?.catalogue?.groupe_model?.name
                  ? ` (${cmd?.catalogue?.groupe_model?.name} ${cmd?.catalogue?.groupe_model_var || ''})`
                  : ''}
              </Typography>

              <Grid container spacing={1.5} mt={0.5}>
                <Grid item xs={6} sm={4}>
                  <Typography variant="caption" color="text.secondary" display="block">
                    Type Métal
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {cmd?.catalogue?.type_metal
                      ? metaux?.find((el) => el?.value === cmd?.catalogue?.type_metal)?.label ||
                        '--'
                      : '--'}
                  </Typography>
                </Grid>

                <Grid item xs={6} sm={4}>
                  <Typography variant="caption" color="text.secondary" display="block">
                    Couleur Or
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {cmd?.catalogue?.couleur_or || '--'}
                  </Typography>
                </Grid>

                <Grid item xs={6} sm={4}>
                  <Typography variant="caption" color="text.secondary" display="block">
                    Famille
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {cmd?.catalogue?.famille || '--'}
                  </Typography>
                </Grid>

                <Grid item xs={6} sm={4}>
                  <Typography variant="caption" color="text.secondary" display="block">
                    Diamant
                  </Typography>
                  <Chip
                    size="small"
                    color={cmd?.catalogue?.is_diamant ? 'success' : 'default'}
                    label={cmd?.catalogue?.is_diamant ? 'Oui' : 'Non'}
                    sx={{ height: 20, fontSize: '0.7rem' }}
                  />
                </Grid>

                <Grid item xs={6} sm={4}>
                  <Typography variant="caption" color="text.secondary" display="block">
                    Modèle Suivi
                  </Typography>
                  <Chip
                    size="small"
                    color={cmd?.catalogue?.is_modele_suivi ? 'success' : 'default'}
                    label={cmd?.catalogue?.is_modele_suivi ? 'Oui' : 'Non'}
                    sx={{ height: 20, fontSize: '0.7rem' }}
                  />
                </Grid>

                <Grid item xs={6} sm={4}>
                  <Typography variant="caption" color="text.secondary" display="block">
                    Délais Fab.
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {findCataloguDelaisLivraison(cmd?.catalogue)} jours
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Custom Specs Bar */}
            <Grid item xs={12}>
              <Grid container spacing={1.5}>
                <Grid item xs={4}>
                  <StatBox label="Taille" value={cmd?.taille} color="#159073" />
                </Grid>
                <Grid item xs={4}>
                  <StatBox label="Gravure" value={cmd?.gravure} color="#9761cd" />
                </Grid>
                <Grid item xs={4}>
                  <StatBox
                    label="Prix Vente TTC"
                    value={
                      cmd?.catalogue?.is_sur_mesure || cmd?.catalogue?.is_hc
                        ? `${cmd?.prix_sur_mesure_ttc || 0} €`
                        : `${cmd?.catalogue?.prix_vente_ttc || 0} €`
                    }
                    color="#00a86b"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Section>

      {/* Linked Sales Document (Vente) */}
      {cmd?.document_client && (
        <Section sx={{ mb: 2 }}>
          <SectionHeader
            icon={<Receipt fontSize="small" />}
            color="#2196F3"
            title="Vente / Document Client"
          />
          <Box sx={{ p: 2, pt: 0 }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Box>
                <Typography variant="caption" color="text.secondary" display="block">
                  Document N°
                </Typography>
                <Typography
                  component={Link}
                  to={`/app/caisse/doc-client/${cmd.document_client.idDoc}`}
                  target="_blank"
                  variant="subtitle1"
                  fontWeight={700}
                  color="primary.main"
                  sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                >
                  {cmd.document_client.num || '--'} <OpenInNew fontSize="inherit" />
                </Typography>
              </Box>

              <Box>
                <Typography variant="caption" color="text.secondary" display="block">
                  Client Attaché
                </Typography>
                <Typography variant="subtitle2" fontWeight={600}>
                  {cmd.document_client.client
                    ? `${cmd.document_client.client.nom} ${cmd.document_client.client.prenom || ''}`
                    : '--'}
                </Typography>
              </Box>
            </Stack>
          </Box>
        </Section>
      )}

      {/* Linked Inventory Stock */}
      <Section sx={{ mb: 2 }}>
        <SectionHeader icon={<Inventory fontSize="small" />} color="#e08e2b" title="Stock Lié" />
        <Box sx={{ px: 2, pb: 2 }}>
          {cmd?.stock ? (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Code Inventaire</TableCell>
                  <TableCell>Statut</TableCell>
                  <TableCell>Magasin</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography variant="body2" fontWeight={700}>
                      {cmd.stock.code_inventaire}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip size="small" label={cmd.stock.status} color="info" />
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">{cmd.stock.magasin?.code || 'Central'}</Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          ) : (
            <Typography variant="body2" color="text.secondary" textAlign="center" py={1}>
              Aucun stock spécifique actuellement réservé.
            </Typography>
          )}
        </Box>
      </Section>

      {/* Attached Photos Grid */}
      <Section sx={{ mb: 2 }}>
        <SectionHeader
          icon={<PhotoCamera fontSize="small" />}
          color="#8a55c4"
          title="Photos Jointes"
        />
        <Box sx={{ p: 2, pt: 0 }}>
          <Grid container spacing={2}>
            {['photo_1', 'photo_2', 'photo_3'].map((field, index) => {
              const photoPath = cmd?.[field];
              return (
                <Grid item xs={12} sm={4} key={field}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 1.5,
                      textAlign: 'center',
                      bgcolor: (t) => alpha(t.palette.text.primary, 0.02),
                    }}
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      mb={1}
                    >
                      <Typography variant="caption" fontWeight={700}>
                        Photo {index + 1}
                      </Typography>
                      <Stack direction="row" spacing={0.5}>
                        {photoPath && (
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => onDeletePhoto(field)}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        )}
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => onOpenPhotoUploadModal(field)}
                        >
                          <UploadFile fontSize="small" />
                        </IconButton>
                      </Stack>
                    </Stack>

                    {photoPath ? (
                      <ImageZoomer
                        imageUrl={`${api_file_url_cmd_fb}${photoPath}`}
                        style={{ height: 100, width: '100%', objectFit: 'contain' }}
                      />
                    ) : (
                      <Box
                        sx={{
                          height: 100,
                          display: 'grid',
                          placeItems: 'center',
                          border: '1px dashed',
                          borderColor: 'divider',
                          borderRadius: 1,
                          color: 'text.disabled',
                        }}
                      >
                        <Typography variant="caption">Aucune photo</Typography>
                      </Box>
                    )}
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Section>

      {/* Upload Modal Wrapper */}
      <FileUploadModal
        show={show_file_modal}
        loading={loading}
        onUpload={onConfirmPhotoUpload}
        onClose={() => set_show_file_modal(false)}
      />
    </Box>
  );
};

const CmdHistoriqueSection = ({ cmd }) => {
  const histories = useMemo(() => {
    if (!Array.isArray(cmd?.historiques)) return [];
    return [...cmd.historiques].sort(
      (a, b) => new Date(b?.date).getTime() - new Date(a?.date).getTime(),
    );
  }, [cmd?.historiques]);

  return (
    <Section sx={{ mb: 2 }}>
      <SectionHeader
        icon={<History fontSize="small" />}
        color="#159073"
        title="Journal de l'Historique"
      />
      <Box sx={{ px: 2, pb: 2 }}>
        {histories.length === 0 ? (
          <Typography variant="body2" color="text.secondary" textAlign="center" py={2}>
            Aucun historique enregistré.
          </Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Action / Statut</TableCell>
                <TableCell>Fait le</TableCell>
                <TableCell>Fait par</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {histories.map((row, idx) => (
                <TableRow key={`hist-${cmd?.idCmdFournisseur}-${idx}`} hover>
                  <TableCell>
                    <Typography variant="body2" fontWeight={600} color="primary.main">
                      {row?.task || '--'}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption" color="text.secondary">
                      {row?.date
                        ? `${String(row.date).substring(0, 10)} ${String(row.date).substring(11, 16)}`
                        : '--'}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip size="small" label={row?.user || 'Système'} variant="outlined" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Box>
    </Section>
  );
};

const CmdBlocageSection = ({ cmd, onUpdateValues }) => {
  const [show_form, set_show_form] = useState(false);
  const [lst_blocage, set_lst_blocage] = useState([]);
  const [sel_type, set_sel_type] = useState('autre');
  const [sel_note, set_sel_note] = useState('');

  useEffect(() => {
    if (Array.isArray(cmd?.bloquages)) set_lst_blocage(cmd.bloquages);
  }, [cmd]);

  const onSubmitBlocage = () => {
    if (Array.isArray(lst_blocage)) {
      const updated = [
        ...lst_blocage,
        {
          id: lst_blocage.length + 1,
          type: sel_type,
          note: sel_note,
          date: new Date(),
          user: 'super admin',
          status: 'non-resolus',
        },
      ];
      onUpdateValues({ idCmdFournisseur: cmd?.idCmdFournisseur, bloquages: updated });
      onCloseForm();
    }
  };

  const onResolveBlocage = (id) => {
    if (Array.isArray(lst_blocage)) {
      const updated = lst_blocage.map((el) => (el?.id === id ? { ...el, status: 'resolus' } : el));
      onUpdateValues({ idCmdFournisseur: cmd?.idCmdFournisseur, bloquages: updated });
    }
  };

  const onCloseForm = () => {
    set_sel_note('');
    set_sel_type('autre');
    set_show_form(false);
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" fontWeight={700}>
          Gestion des Blocages ({lst_blocage.length})
        </Typography>
        {!show_form && (
          <Button
            variant="contained"
            color="error"
            size="small"
            startIcon={<WarningAmber fontSize="small" />}
            onClick={() => set_show_form(true)}
          >
            Notifier un Blocage
          </Button>
        )}
      </Stack>

      {show_form && (
        <Paper
          variant="outlined"
          sx={{ p: 2, mb: 2, bgcolor: alpha('#e2445c', 0.05), borderColor: '#e2445c' }}
        >
          <Typography variant="subtitle2" fontWeight={700} mb={1.5}>
            Nouveau Blocage
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                size="small"
                select
                label="Type de blocage"
                value={sel_type}
                onChange={(e) => set_sel_type(e.target.value)}
              >
                <MenuItem value="autre">Autre</MenuItem>
                <MenuItem value="fourniture">Fourniture</MenuItem>
                <MenuItem value="modele">Modèle</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                size="small"
                label="Note explicative"
                multiline
                rows={2}
                value={sel_note}
                onChange={(e) => set_sel_note(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} textAlign="end">
              <Button size="small" onClick={onCloseForm} sx={{ mr: 1 }}>
                Annuler
              </Button>
              <Button variant="contained" color="error" size="small" onClick={onSubmitBlocage}>
                Enregistrer Blocage
              </Button>
            </Grid>
          </Grid>
        </Paper>
      )}

      <Section sx={{ mb: 0 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell>Note</TableCell>
              <TableCell>Statut</TableCell>
              <TableCell>Date</TableCell>
              <TableCell align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lst_blocage.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 3, color: 'text.secondary' }}>
                  Aucun blocage signalé.
                </TableCell>
              </TableRow>
            ) : (
              lst_blocage.map((el) => (
                <TableRow key={el.id} hover>
                  <TableCell>
                    <Chip
                      size="small"
                      label={el.type}
                      color={el.type === 'fourniture' ? 'error' : 'warning'}
                    />
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">{el.note || '--'}</Typography>
                  </TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={el.status === 'resolus' ? 'Résolu' : 'En cours'}
                      color={el.status === 'resolus' ? 'success' : 'error'}
                    />
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption">{String(el.date).slice(0, 10)}</Typography>
                  </TableCell>
                  <TableCell align="right">
                    {el.status !== 'resolus' && (
                      <Button
                        size="small"
                        variant="outlined"
                        color="success"
                        onClick={() => onResolveBlocage(el.id)}
                      >
                        Résoudre
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Section>
    </Box>
  );
};

const CmdNoteSection = ({ cmd, onUpdateValues }) => {
  const [show_form, set_show_form] = useState(false);
  const [lst_note, set_lst_note] = useState([]);
  const [sel_type, set_sel_type] = useState('');
  const [sel_note, set_sel_note] = useState('');

  useEffect(() => {
    if (Array.isArray(cmd?.notes)) set_lst_note(cmd.notes);
  }, [cmd]);

  const onSubmitNote = () => {
    if (Array.isArray(lst_note)) {
      const updated = [
        ...lst_note,
        {
          id: lst_note.length + 1,
          title: sel_type,
          description: sel_note,
          date: new Date(),
          user: 'super admin',
        },
      ];
      onUpdateValues({ idCmdFournisseur: cmd?.idCmdFournisseur, notes: updated });
      onCloseForm();
    }
  };

  const onCloseForm = () => {
    set_sel_note('');
    set_sel_type('');
    set_show_form(false);
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" fontWeight={700}>
          Notes & Remarques ({lst_note.length})
        </Typography>
        {!show_form && (
          <Button
            variant="contained"
            color="success"
            size="small"
            startIcon={<NoteAdd fontSize="small" />}
            onClick={() => set_show_form(true)}
          >
            Ajouter une Note
          </Button>
        )}
      </Stack>

      {show_form && (
        <Paper
          variant="outlined"
          sx={{ p: 2, mb: 2, bgcolor: alpha('#159073', 0.05), borderColor: '#159073' }}
        >
          <Typography variant="subtitle2" fontWeight={700} mb={1.5}>
            Nouvelle Note
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Titre de la note"
                value={sel_type}
                onChange={(e) => set_sel_type(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Description détaillée"
                multiline
                rows={3}
                value={sel_note}
                onChange={(e) => set_sel_note(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} textAlign="end">
              <Button size="small" onClick={onCloseForm} sx={{ mr: 1 }}>
                Annuler
              </Button>
              <Button variant="contained" color="success" size="small" onClick={onSubmitNote}>
                Enregistrer Note
              </Button>
            </Grid>
          </Grid>
        </Paper>
      )}

      <Stack spacing={1.5}>
        {lst_note.length === 0 ? (
          <Typography variant="body2" color="text.secondary" textAlign="center" py={3}>
            Aucune note associée.
          </Typography>
        ) : (
          lst_note.map((el) => (
            <Paper key={el.id} variant="outlined" sx={{ p: 2, borderRadius: 1.5 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                <Typography variant="subtitle2" fontWeight={700} color="primary.main">
                  {el?.title || 'Note'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {String(el?.date).substring(0, 10)}
                </Typography>
              </Stack>
              <Typography variant="body2" color="text.primary" paragraph sx={{ mb: 1 }}>
                {el?.description}
              </Typography>
              <Typography variant="caption" color="text.secondary" display="block" textAlign="end">
                Par: <strong>{el?.user || 'Inconnu'}</strong>
              </Typography>
            </Paper>
          ))
        )}
      </Stack>
    </Box>
  );
};

const ControleQualiteSection = ({ cmd }) => {
  const cq = cmd?.cq;

  if (!cq) {
    return (
      <Alert severity="warning" variant="outlined" sx={{ borderRadius: 2 }}>
        Aucun contrôle qualité n'a encore été effectué pour cette commande.
      </Alert>
    );
  }

  return (
    <Box>
      <Section sx={{ mb: 2 }}>
        <SectionHeader
          icon={<FactCheck fontSize="small" />}
          color={cq.is_valide ? '#00a86b' : '#e2445c'}
          title="Rapport de Contrôle Qualité"
          subtitle={cq.created_at ? `Effectué le: ${String(cq.created_at).slice(0, 10)}` : ''}
          right={
            <Chip
              color={cq.is_valide ? 'success' : 'error'}
              label={cq.is_valide ? 'Validé' : 'Non Validé'}
              sx={{ fontWeight: 700, borderRadius: 1 }}
            />
          }
        />
        <Box sx={{ p: 2, pt: 0 }}>
          {cq.note && (
            <Alert severity="info" sx={{ mb: 2 }}>
              <strong>Remarque du contrôleur:</strong> {cq.note}
            </Alert>
          )}

          {/* Validation Checks Grid */}
          <Grid container spacing={1.5} mb={2}>
            {[
              { label: 'Taille', value: cq.taille, valid: cq.is_taille_valide },
              { label: 'Gravure', value: cq.gravure, valid: cq.is_gravure_valide },
              { label: 'Couleur Or', value: cq.couleur, valid: cq.is_couleur_valide },
              {
                label: 'Métal',
                value: metaux?.find((el) => el.value === cq.metal)?.label,
                valid: cq.is_metal_valide,
              },
              {
                label: 'Poids CTS',
                value: cq.poids_cts ? `${cq.poids_cts} CTS` : null,
                valid: cq.is_poids_cts_valide,
              },
              { label: 'PC', value: cq.pc ? `${cq.pc} CTS` : null, valid: cq.is_pc_valide },
              { label: 'PPVG', value: cq.pv ? `${cq.pv} CTS` : null, valid: cq.is_pv_valide },
            ].map((check, i) => (
              <Grid item xs={6} sm={3} key={i}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 1.5,
                    textAlign: 'center',
                    bgcolor: alpha(check.valid ? '#00a86b' : '#e2445c', 0.05),
                    borderColor: check.valid ? '#00a86b' : '#e2445c',
                  }}
                >
                  <Typography variant="caption" color="text.secondary" display="block">
                    {check.label}
                  </Typography>
                  <Typography variant="subtitle2" fontWeight={700} my={0.5}>
                    {check.value || '--'}
                  </Typography>
                  <Chip
                    size="small"
                    color={check.valid ? 'success' : 'error'}
                    label={check.valid ? 'Valide' : 'Non Valide'}
                    sx={{ height: 18, fontSize: '0.65rem', fontWeight: 700 }}
                  />
                </Paper>
              </Grid>
            ))}
          </Grid>

          {/* Stones Detail Table */}
          {Array.isArray(cq.pierres) && cq.pierres.length > 0 && (
            <Box mt={2}>
              <Typography variant="subtitle2" fontWeight={700} mb={1}>
                Pierres Contrôlées
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Code Inv</TableCell>
                    <TableCell>Famille</TableCell>
                    <TableCell>Poids CTS</TableCell>
                    <TableCell align="right">Prix Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cq.pierres.map((p, idx) => (
                    <TableRow key={idx}>
                      <TableCell>
                        <Typography variant="body2" fontWeight={600}>
                          {p?.ref_pierre || '(Fournisseur)'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          size="small"
                          label={p?.famille}
                          color={p?.famille === 'centrale' ? 'success' : 'primary'}
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">{p?.poids_total_cts} CTS</Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography variant="body2" fontWeight={700} color="success.main">
                          {p?.prix_total || 0} €
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          )}
        </Box>
      </Section>
    </Box>
  );
};

const BonCommandePrintButton = ({ commande }) => {
  const cmd_bon_print = useRef();
  const onPrintBon = useReactToPrint({
    documentTitle: 'Bon de commande',
    content: () => cmd_bon_print.current,
    copyStyles: true,
  });
  return (
    <>
      <Button
        variant="contained"
        size="medium"
        color="info"
        onClick={onPrintBon}
        sx={{ mx: 1, mt: 1 }}
      >
        Imprimer Bon
      </Button>
      <div style={{ display: 'none' }}>
        <TableContainer sx={{ background: 'white', px: '40px', py: '20px' }}>
          <Printable ref={cmd_bon_print}>
            <React.Fragment key={commande?.ref}>
              <Table
                size="small"
                stickyHeader
                sx={{
                  border: '#000 1px solid',
                  '& .MuiTableCell-root': {
                    backgroundColor: 'inherit',
                    fontSize: '12px',
                    color: 'black',
                  },
                }}
              >
                <TableBody>
                  <TableRow>
                    <TableCell rowSpan={3} sx={{ textAlign: 'center', width: '25%' }}>
                      <img
                        src={`${api_file_url_catalogue}${commande?.catalogue?.img}`}
                        width={'100%'}
                        alt=""
                      />
                    </TableCell>

                    <TableCell sx={{ textAlign: 'start' }} colSpan={2}>
                      <Typography variant="inherit">Bon de commande N°</Typography>
                      <Typography variant="inherit" fontWeight={600}>
                        {commande?.ref}
                      </Typography>
                      <Typography variant="inherit">
                        Date livraison: <b>{formatFrenchDate(commande?.date_livraison)}</b>
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ textAlign: 'end' }} colSpan={2}>
                      <QRCode
                        value={JSON.stringify({
                          type: 'bon-commande',
                          id: commande?.idCmdFournisseur,
                        })}
                        size={64}
                      />
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ textAlign: 'start', minWidth: 160 }}>
                      <Typography variant="inherit">Type</Typography>
                      <Typography variant="inherit" fontWeight={600}>
                        {commande?.type_commande}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ textAlign: 'start', minWidth: 120 }}>
                      <Typography variant="inherit">Magasin</Typography>
                      <Typography variant="inherit" fontWeight={600}>
                        {commande?.magasin?.code}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ textAlign: 'start' }} colSpan={2}>
                      <Typography variant="inherit">Client</Typography>
                      <Typography variant="inherit" fontWeight={600}>
                        {commande?.client
                          ? `${commande?.client?.nom} ${commande?.client?.prenom}`
                          : '----'}
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ textAlign: 'start' }}>
                      <Typography variant="inherit">SKU</Typography>
                      <Typography variant="inherit" fontWeight={600}>
                        {commande?.catalogue?.sku}
                        {commande?.catalogue?.groupe_model?.name
                          ? ` (${commande?.catalogue?.groupe_model?.name} ${commande?.catalogue?.groupe_model_var})`
                          : ''}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ textAlign: 'start' }}>
                      <Typography variant="inherit">Taille</Typography>
                      <Typography variant="inherit" fontWeight={600}>
                        {commande?.cq?.taille ?? commande?.taille ?? '----'}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ textAlign: 'start' }}>
                      <Typography variant="inherit">Gravure</Typography>
                      <Typography variant="inherit" fontWeight={600}>
                        {commande?.cq?.gravure ?? commande?.gravure ?? '----'}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ textAlign: 'start' }}>
                      <Typography variant="inherit">Couleur</Typography>
                      <Typography variant="inherit" fontWeight={600}>
                        {commande?.cq?.couleur ?? commande?.couleur ?? '----'}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </React.Fragment>
          </Printable>
        </TableContainer>
      </div>
    </>
  );
};

const Printable = React.forwardRef((props, ref) => {
  const StyledDiv = styled('div')({
    '@media print': {
      margin: '30mm 10mm 30mm 10mm !important',
    },
  });

  return <StyledDiv ref={ref} {...props} />;
});
export default CmdFbDetailsWidget;
